import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { toast, ToastContainer } from "react-toastify";
import useApiFunction from "../../api/useApiFunction";
import valueContext from "../../customHook/useContext";

function CoreIncentiveDistribution() {
  let [search, setSearch] = useState({
    core_a: "",
    core_b: "",
    tId_a: "",
    tId_b: ""
  });
  const { joinToken } = useContext(valueContext);
  const location = useLocation();
  const token = joinToken();
  const [isLoading, setIsLoading] = useState(false);
  const { formDataFunc } = useApiFunction();
  const navigate = useNavigate();
  const handleChange = e => {
    setSearch({
      ...search,
      [e.target.name]: e.target.value
    });
  };

  async function submit(e) {
    e.preventDefault();
    setIsLoading(true);
    if (
      (!search.core_a && !search.core_b) ||
      (!search.tId_a && !search.tId_b)
    ) {
      toast.warning("Please fill the detail", {
        autoClose: 2000
      });
      setIsLoading(false);
    } else {
      let body = JSON.stringify({
        twlId: search.tId_a ? search.tId_a : search.tId_b
      });

      const res = await formDataFunc(`admin/check-member`, body, "POST", token);
      if (res.status) {
        toast.success(res.msg, { autoClose: 2000 });
        navigate("/admin/details", {
          state: { data: { ...res.msg, ...search } }
        });
      } else if (
        res.error &&
        (res.error === "ERROR_TOKEN_INVALID0" ||
          res.error === "ERROR_TOKEN_INVALID1" ||
          res.error === "user not registered" ||
          res.error === "ERROR_TOKEN_INVALID2" ||
          res.error === "ERROR_TOKEN_INVALID3" ||
          res.error === "unauthorized" ||
          res.error === "Your session has expierd Please login again 1" ||
          res.error === "Your session has expierd Please login again 2")
      ) {
        window.localStorage.removeItem("_A");
        window.localStorage.removeItem("_B");
        window.localStorage.removeItem("_C");
        navigate("/admin/login");
      } else if (res.error) {
        toast.warning(res.error, { autoClose: 2000 });
      } else {
        toast.warning(res.msg, { autoClose: 2000 });
      }

      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (location?.state?.toast) {
      toast.success(location.state.toast, { autoClose: 2000 });
      delete location.state.toast;
    }
  }, []);

  return (
    <>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0 font-size-18">Core Incentive</h4>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="card profile-section">
                  <div className="card-body">
                    <div className="col-lg-12 col-md-12 col-sm-6">
                      <form onSubmit={e => submit(e)} id="1">
                        {/* <span className="span-title">Core A</span> */}
                        <div className="form-group mb-3">
                          <label for="" className="sub-heading col-form-label">
                            Coin Distribute
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Enter Amount of Coin Distribution"
                            name="core_a"
                            value={search.core_a}
                            onChange={e => {
                              handleChange(e);
                            }}
                          />
                        </div>

                        <div className="form-group mb-3">
                          <label for="" className="sub-heading col-form-label">
                            Tallwin Id
                          </label>
                          <input
                            className="form-control"
                            placeholder="Enter Tallwin Id"
                            name="tId_a"
                            value={search.tId_a}
                            onChange={e => {
                              handleChange(e);
                            }}
                          />
                        </div>

                        <div className="mt-3">
                          <button
                            className="block-menu"
                            type="submit"
                            disabled={isLoading}
                          >
                            {isLoading && (
                              <i
                                className="bx bx-loader-circle rotating"
                                style={{ marginRight: "5px" }}
                              />
                            )}
                            Submit
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="col-md-6">
                <div className="card profile-section">
                  <div className="card-body">
                    <div className="col-lg-12 col-md-12 col-sm-6">
                      <form onSubmit={e => submit(e)} id="2">
                        <span className="span-title">Core B</span>
                        <div className="form-group mb-3">
                          <label for="" className="sub-heading col-form-label">
                            Coin Distribute
                          </label>
                          <input
                            type="number"
                            name="core_b"
                            className="form-control"
                            placeholder="Enter Amount of Coin Distribution"
                            value={search.core_b}
                            onChange={e => {
                              handleChange(e);
                            }}
                          />
                        </div>
                        <div className="form-group mb-3">
                          <label for="" className="sub-heading col-form-label">
                            Tallwin Id
                          </label>
                          <input
                            className="form-control"
                            placeholder="Enter Tallwin Id"
                            name="tId_b"
                            value={search.tId_b}
                            onChange={e => {
                              handleChange(e);
                            }}
                          />
                        </div>

                        <div className="mt-3">
                          <button
                            className="block-menu"
                            type="submit"
                            disabled={isLoading1}
                          >
                            {isLoading1 && (
                              <i
                                className="bx bx-loader-circle rotating"
                                style={{ marginRight: "5px" }}
                              />
                            )}
                            Submit
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
}

export default CoreIncentiveDistribution;
